// extracted by mini-css-extract-plugin
export default {"banner":"BannerItem_banner__yK1wv"};